import { useEffect, useState } from "react";

/** The open pin's desktop infobox (map-view). The id is also the e2e hook. */
export const MAP_INFOBOX_ID = "map-infobox";

function overInfobox(x: number, y: number): boolean {
  const infobox = document.getElementById(MAP_INFOBOX_ID);
  if (!infobox) return false;
  const rect = infobox.getBoundingClientRect();
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}

/**
 * True while the pointer rests over the open pin's infobox, tracked only while
 * `active` (the search field's click-away layer is up). The layer must spend a
 * press on the MAP, never on the infobox: the infobox paints inside the Google
 * Maps DOM, so it cannot rise above a layer over the map, and a click on a
 * project card was spent on leaving the search. The host lets presses through
 * the layer while this holds. A press is always preceded by the pointer
 * arriving, so the move that brings it over the card has already decided.
 */
export function useClickAwayPassThrough(active: boolean): boolean {
  const [passThrough, setPassThrough] = useState(false);
  useEffect(() => {
    if (!active) {
      setPassThrough(false);
      return;
    }
    const track = (event: PointerEvent) =>
      setPassThrough(overInfobox(event.clientX, event.clientY));
    // Capture: the infobox stops its own pointer events from reaching the map.
    window.addEventListener("pointermove", track, { capture: true });
    return () =>
      window.removeEventListener("pointermove", track, { capture: true });
  }, [active]);
  return passThrough;
}
